export const labelText = 'Drop files here or click to upload.'
export const loadingText = 'Loading...'
export const maxSizeText = 'Max size 5MB'
export const imageOnlyText = 'Image only'